import { RunParameter } from "../../../../../api";
import { IParameterRenderer, RenderParamLabSettingsProps } from "../../ParameterRendererAbstracts";
import { CaseRunCalculateModel, CaseRunClient, CaseRunCreateModelBase, FamilialSearchCaseRunCreateModel } from "@app/api2/api";
import { ICreateRenderer } from "../../CaseRunCreate";
import { InformactionFamilialSearch, InformationFamilialSearchState } from "./InformationFamilialSearch";
import React from "react";
import { ReviewFamilialSearch } from "./ReviewFamilialSearch";
import moment from 'moment';
import ReactDatePicker from 'react-datepicker'
// import "react-datepicker/dist/react-datepicker.css";
import { LabKitSelector } from "../../LabKitSelector";
import { FamilialSearchResults } from "../../Details/Results/FamilialSearch/FamilialSearchResults";
import { FamilialSearchCaseRuns } from "../../Details/Results/FamilialSearch/FamilialSearchCaseRuns";

export class FamilialSearchHandler implements IParameterRenderer, ICreateRenderer<FamilialSearchCaseRunCreateModel, InformationFamilialSearchState> {
    caseRunClient = new CaseRunClient();

    save(props: { labId: number, caseId: number, model: CaseRunCreateModelBase }) {
        return new CaseRunClient().createFamilialSearch(props.labId, props.caseId, props.model)
    }

    createBlankModel(props: { labId: number, caseId: number, runType: string, evidenceId?: number, ednaTestId?: number }): Promise<FamilialSearchCaseRunCreateModel> {
        return this.caseRunClient.new(props.labId, props.caseId, props.runType, props.evidenceId, props.ednaTestId ?? null)
    }

    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return <ReviewFamilialSearch parameterRenderer={this} model={model as FamilialSearchCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return <InformactionFamilialSearch model={model as FamilialSearchCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    runType: string = "familial_search";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    applyInformationValuesToModel = (model: FamilialSearchCaseRunCreateModel, values: InformationFamilialSearchState) => {
        // model = fillWithValues(model, values, false)
        model.description = values.description;
        // model.evidence = values.evidence;
        model.populationId = values.populationId;
        model.references = values.references;
        // model.qualityCheckCases = values.qualityCheckCases;

        let start = new Date();
        start.setDate(new Date().getDate() - 30);
        var startPar = model.parameters.find(x => x.parameter == "kinUploadStartDate");
        var endPar = model.parameters.find(x => x.parameter == "kinUploadEndDate");

        if (startPar != null && (startPar.value == null || startPar.value == ""))
            startPar.value = moment(start).format("MM/DD/YYYY");

        if (endPar != null && (endPar.value == null || endPar.value == ""))
            endPar.value = moment(new Date()).format("MM/DD/YYYY");

        return model;
    };

    propsComplete = (model: CaseRunCreateModelBase): void => {
        model.parameters = model.parameters.sort((a, b) => a.order < b.order ? -1 : 1)
    };


    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameter, values, onChange, errors, setFieldValue): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector readOnly={false} optionalText="None" kitId={parseInt(p.value)} name={p.parameter} labId={model.labId} onChange={async (ev) => {
                    setFieldValue(p.parameter, ev)
                    onChange(p, ev)
                }} />);
        } else {
            return (
                // <Input type="text" name={p.parameter} value={values[p.parameter] || ''} onChange={(ev, data) => {
                //     console.log(data.value);
                //     setFieldValue(p.parameter, data.value);
                //     return onChange(p, data.value);
                // }} />
                <ReactDatePicker autoComplete="off" isClearable={true} name={p.parameter} selected={values[p.parameter] ? moment(values[p.parameter], "MM/DD/YYYY").toDate() : null}
                    onChange={(ev) => {
                        let dateValue = ev as Date != null ? moment(ev as Date).format("MM/DD/YYYY") : null;
                        setFieldValue(p.parameter, dateValue)
                        return onChange(p, dateValue);
                    }} />
            );
        }
    }

    canRenderParameter(parameterName: string): boolean {
        return ["kinUploadStartDate", "kinUploadEndDate", "kitId"].some(pname => pname == parameterName);
    }

    renderParameterView({ model, p }): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector readOnly={true} kitId={parseInt(p.value)} name={p.parameter} labId={model.labId} />
            );
        } else {
            return (
                <span>{p.value}</span>
            );
        }
    }

    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        if (p.parameter == "kitId") {
            return (
                <LabKitSelector optionalText="None" readOnly={p.readOnly} kitId={parseInt(p.value)} name={p.parameter} labId={p.labId} onChange={(a) => { p.onChange(a as any) }} />
            );
        }
        return null;
    }

    renderResults?: (props: { labId: number, caseId: number, caseRunId: number }) => React.ReactElement = (props) => {
        return <FamilialSearchResults caseId={props.caseId} labId={props.labId} caseRunId={props.caseRunId} />
    };

    renderRunList?: (props: { canCreateEvidence: boolean, labId: number, caseId: number }) => React.ReactElement = (props) => <FamilialSearchCaseRuns {...props} />

    cloneCaseRun?: (props: { labId: number, caseId: number, copyFrom: number }) => Promise<FamilialSearchCaseRunCreateModel> = (props) => {
        return this.caseRunClient.cloneFamilialSearch(props.labId, props.caseId, props.copyFrom)
    }


}
